import barba from '@barba/core';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { splashEnter, splashExit } from '../animation/splash.js';
import { homeEnter, homeExit, buySection } from '../animation/homepage.js';

// import CircuitsAnim from '../components/circuits.js';


// gsap.registerPlugin(ScrollTrigger);

let barbaInitialized = false;
let ctx;

export const initBarba = () => {
	if (barbaInitialized) return;
	
	barbaInitialized = true;
	
	barba.init({
		preventRunning: true,
		transitions: [
			{
				name: 'splash',
				to: {
					namespace: ['splash']
				},
				once: (data) => splashEnter(data)
			},
			{
				name: 'from splash to home',
				from: {
					namespace: ['splash']
				},
				to: {
					namespace: ['home']
				},	
				leave: (data) => splashExit(data),
				after: (data) => {
					homeEnter(data);
					buySection(data);
				}
			},
			{
				name: 'home',
				to: {
					namespace: ['home']
				},
				once: (data) => {
					homeEnter(data)
					buySection(data)
				}
			},
			{
				name: 'from home to splash',
				from: {
					namespace: ['home']
				},
				to: {
					namespace: ['splash']
				},
				leave: (data) => homeExit(data),
				after: (data) => splashEnter(data)
			},
			{
				name: 'language change',
				from: {
					namespace: ['home']
				},
				to: {
					namespace: ['home']
				},
				leave: (data) => homeExit(data, 'self'),
				after: (data) => {
					homeEnter(data);
					buySection(data);
				}
			}
		],
		views: [
		// {
		// 	namespace: 'splash',
		// 	beforeEnter: data => {
		// 		splashEnter(data)
		// 	}
		// },
		// {
		// 	namespace: 'home',
		// 	// 1. PULIZIA (Critico)
		// 	afterLeave() {
		// 		// Uccidi TUTTE le animazioni e ScrollTrigger della pagina vecchia in un colpo solo
		// 		if (ctx) ctx.revert(); 
				
		// 		// Disabilita ScrollTrigger durante la transizione per evitare calcoli inutili
		// 		ScrollTrigger.disable();
		// 	},
		// 	// 2. INIZIALIZZAZIONE (Ottimizzata)
		// 	afterEnter(data) {
		// 		// Riabilita ScrollTrigger (senza ricalcolare ancora)
		// 		ScrollTrigger.enable();

		// 		// Creiamo un NUOVO contesto per la nuova pagina
		// 		ctx = gsap.context(() => {

		// 			const modules = [...data.next.container.querySelectorAll('[data-module]')];
					
		// 			modules.forEach(section => {
		// 				const type = section.dataset.module;
						
		// 				// Switch semplice o mapping object
		// 				if (type === 'circuits') new CircuitsAnim(section);
						
		// 			});

		// 		}, data.next.container); 
		// 		// Scope: limita le query solo al nuovo container
				
		// 		// Forza un refresh delle posizioni di ScrollTrigger ora che il DOM è pronto
		// 		ScrollTrigger.refresh();
		// 	}
		// },

	]
	})
}